import { render } from "./FactForecast.vue?vue&type=template&id=365dd23b&scoped=true"
import script from "./FactForecast.vue?vue&type=script&lang=js"
export * from "./FactForecast.vue?vue&type=script&lang=js"

import "./FactForecast.vue?vue&type=style&index=0&id=365dd23b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365dd23b"]])

export default __exports__